import { inject } from '@angular/core';
import type { CanActivateFn } from '@angular/router';
import { NavigationService } from '@core/navigation/services/navigation.service';
import { MaintenanceService } from '@core/pages/error-pages/maintenance-page/services/maintenance.service';
import { AppPathsMap } from '@core/routing/app-paths';

export const checkMaintenanceGuard: CanActivateFn = (route, state) => {
  const navigationService = inject(NavigationService);
  const maintenanceService = inject(MaintenanceService);

  const isMaintenanceActive = maintenanceService.isMaintenanceActive();

  if (isMaintenanceActive) {
    if (state.url !== `/${AppPathsMap.Error.Maintenance}`) {
      return navigationService.createUrlTree([AppPathsMap.Error.Maintenance]);
    }
  } else {
    if (state.url === `/${AppPathsMap.Error.Maintenance}`) {
      return navigationService.createUrlTree([AppPathsMap.Homepage]);
    }
  }
  return true;
};
